import React, { useEffect, useRef, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import logo from "../../assests/images/logo2.png";
const NavBar = () => {
  const [open, setOpen] = useState(false);
  const toggle = useRef(null);
  const location = useLocation();
  useEffect(() => { setOpen(false); }, [location]);
  useEffect(() => {
    const close = (event) => { if (event.key === "Escape") { setOpen(false); toggle.current?.focus(); } };
    if (open) document.addEventListener("keydown", close);
    return () => document.removeEventListener("keydown", close);
  }, [open]);
  return (
    <header className="tb-header">
      <a className="tb-skip-link" href="#main-content">Hoppa till innehållet</a>
      <div className="tb-topbar"><div className="tb-container"><p>Wedavägen 4C, Södertälje</p><p>Mån–fre 09:30–17:30 <span aria-hidden="true">·</span> Lör 11:00–15:00</p><a href="tel:+46855066158">08-550 66 158</a></div></div>
      <div className="tb-container tb-nav-row">
        <NavLink to="/" className="tb-brand" aria-label="Touza Bilar – startsida"><img src={logo} alt="Touza Bilar AB" width="1356" height="723" /></NavLink>
        <button ref={toggle} className="tb-menu-toggle" type="button" aria-expanded={open} aria-controls="tb-navigation" onClick={() => setOpen(!open)}>{open ? "Stäng" : "Meny"}<span aria-hidden="true">{open ? "×" : "☰"}</span></button>
        <nav id="tb-navigation" className={`tb-navigation${open ? " is-open" : ""}`} aria-label="Huvudmeny">
          <NavLink to="/" end onClick={() => setOpen(false)}>Hem</NavLink>
          <a href="https://www.blocket.se/butik/touza-bilar">Bilar i lager <span aria-hidden="true">↗</span></a>
          <NavLink to="/about" onClick={() => setOpen(false)}>Om oss</NavLink>
          <a href="/#contact" onClick={() => setOpen(false)}>Kontakt</a>
        </nav>
        <a className="tb-button tb-button-primary tb-header-cta" href="https://www.blocket.se/butik/touza-bilar">Hitta din bil <span aria-hidden="true">↗</span></a>
      </div>
      {open && <button className="tb-menu-backdrop" type="button" aria-label="Stäng menyn" onClick={() => setOpen(false)} />}
    </header>
  );
};
export default NavBar;
